import { h } from 'preact'
import classNames from 'classnames'

const Tooltip = ({ trigger, qaClasses, customClasses, tooltipMessage, withArrow, position } : {
  trigger: string | JSX.Element,
  qaClasses?: string,
  customClasses?: string,
  tooltipMessage: string | JSX.Element,
  withArrow?: boolean,
  position?: string
}) => (
  <span className='tooltip-container'>
    <span className={`tooltip-trigger ${qaClasses || ''}`}>
      {trigger}
    </span>
    <span className={classNames('tooltip-message', position ? `tooltip-message--${position}` : '', customClasses)}>
      { withArrow && <i class='arrow' /> }
      {tooltipMessage}
    </span>
  </span>
)

export default Tooltip
